/* sp-content-tabs.js — sekme geçişi (tıklama + klavye ok tuşları), aria-selected/tabindex yönetimi ve
   panel kabı yükseklik geçişi. Metin yok: tüm etiketler Liquid'den gelir. */
(function () {
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function select(root, index, moveFocus) {
    var tabs = qsa(root, '[data-sp-ct-tab]');
    var panels = qsa(root, '[data-sp-ct-panel]');
    var box = root.querySelector('[data-sp-ct-panels]');
    if (!tabs.length || !panels[index]) return;
    var current = tabs.indexOf(root.querySelector('[data-sp-ct-tab].is-active'));
    if (current === index) { if (moveFocus) tabs[index].focus(); return; }

    var from = box ? box.offsetHeight : 0;
    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach(function (panel, i) { panel.classList.toggle('is-active', i === index); });

    if (box) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.style.height = from + 'px';
      var to = box.scrollHeight;
      if (reduce || from === to) {
        box.style.height = '';
      } else {
        window.requestAnimationFrame(function () {
          box.style.height = to + 'px';
          var done = function (event) {
            if (event && event.propertyName !== 'height') return;
            box.style.height = '';
            box.removeEventListener('transitionend', done);
          };
          box.addEventListener('transitionend', done);
          window.setTimeout(done, 600);
        });
      }
    }
    if (moveFocus) tabs[index].focus();
  }

  function init(root) {
    if (root.dataset.spCtReady === '1') return;
    root.dataset.spCtReady = '1';
    var tabs = qsa(root, '[data-sp-ct-tab]');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(root, i, false); });
      tab.addEventListener('keydown', function (event) {
        var last = tabs.length - 1;
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i === last ? 0 : i + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i === 0 ? last : i - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        select(root, next, true);
      });
    });
  }

  function boot(scope) { qsa(scope || document, '[data-sp-content-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
